export const mealTypeEnum = Object.freeze({
  all: 'all',
  meal: 'meal',
  catering: 'catering',
  add_ons: 'add_ons',
});
